/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The NewStaticsResponseMeta model module.
 * @module model/NewStaticsResponseMeta
 * @version 1.0.0
 */
class NewStaticsResponseMeta {
    /**
     * Constructs a new <code>NewStaticsResponseMeta</code>.
     * Bloque auxiliar de depuración (opcional). Puede eliminarse en el futuro.
     * @alias module:model/NewStaticsResponseMeta
     */
    constructor() { 
        
        NewStaticsResponseMeta.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>NewStaticsResponseMeta</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NewStaticsResponseMeta} obj Optional instance to populate.
     * @return {module:model/NewStaticsResponseMeta} The populated <code>NewStaticsResponseMeta</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NewStaticsResponseMeta();

            if (data.hasOwnProperty('contract_id')) {
                obj['contract_id'] = ApiClient.convertToType(data['contract_id'], 'Number');
            }
            if (data.hasOwnProperty('apId')) {
                obj['apId'] = ApiClient.convertToType(data['apId'], 'Number');
            }
            if (data.hasOwnProperty('mapped')) {
                obj['mapped'] = ApiClient.convertToType(data['mapped'], 'Boolean');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} contract_id
 */
NewStaticsResponseMeta.prototype['contract_id'] = undefined;

/**
 * @member {Number} apId
 */
NewStaticsResponseMeta.prototype['apId'] = undefined;

/**
 * @member {Boolean} mapped
 */
NewStaticsResponseMeta.prototype['mapped'] = undefined;






export default NewStaticsResponseMeta;

